module.exports = __webpack_public_path__ + "img/en.3e0210d2.svg";